








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { currencyKeyboardEventValidation } from '@/util/CurrencyValidation';
import { CommerceKindParams } from '@/store/interfaces/commerceKind';
import { DraftCompanyParams } from '@/store/interfaces/drafts';

@Component
export default class CommerceInboundForm extends Vue {
  @Prop({
    required: true,
    type: Array,
    default: [],
  })
  commerceKindList!: CommerceKindParams[];

  @Prop({
    required: true,
    type: Object,
    default: {},
  })
  draft!: DraftCompanyParams;

  commerce = {
    commerce_name: '',
    commerce_kind: '', // No definido
    description: '', // No definido
    status: false, // No definido
    tip_percentage: 0, // No definido
    delivery_fee_cents: 0, // No definido
  };

  @Watch('draft', { deep: true, immediate: true, })
  onDraftChange(df: DraftCompanyParams): void {
    this.assignValueToCommerce(df);
  }

  assignValueToCommerce(df: DraftCompanyParams): void {
    this.commerce.commerce_name = df.commerce_name || '';
  }

  currencyKeyboardEventValidation = currencyKeyboardEventValidation;
}
